(ns entities.assets.specs
  (:require
    [cljs.spec.alpha :as s]
    )
  )

(s/def ::id string?)
(s/def ::name string?)
(s/def ::type #{
                "REAL_ESTATE_PROPERTY"
                "BUSINESS"
                "VALUABLE"
                "VEHICLE"
                "OTHER"})
(s/def ::value pos?)

(s/def ::asset (s/keys :req-un [::id
                                ::name
                                ::type
                                ::value]))

(s/def ::assets (s/coll-of ::asset))

(s/def :patch/value (s/or :num number?
                          :str string?))
(s/def :patch/asset (s/keys :req-un [::name
                                     ::type
                                     :patch/value]))
(s/def :patch/assets (s/coll-of :patch/asset))
(s/def ::patch :patch/assets)
